import { rootDoc } from "../../../../helpers/dom-selectors.js";
import makeHeader from "../../../global-components/header.js";
import PasswordChecker from "../../../global-components/password-check.js";
import PasswordInput from "../../../global-components/password-input.js";
import SettingsBtn from "../../../global-components/settings-btn.js";
import ChangePassForm from "../components/change-pass-form.js";
import APP_VIEWS from "./event-router.js";
export default function App({ settingsBtn, settingsOverlay, inputPass, showPassBtn, submitBtn, header, logo }) {
    _initAppShell();
    return Object.freeze({
        resize,
        executeEvent
    });
    function _initAppShell() {
        SettingsBtn({ settingsBtn, settingsOverlay }).init();
        makeHeader({ header, logo }).init();
        PasswordInput({ inputPass, showPassBtn });
        const passwordChecker = new PasswordChecker(inputPass, submitBtn);
        ChangePassForm.init();
    }
    function resize() {
        const vh = window.innerHeight / 100;
        rootDoc.style.setProperty("--vh", vh + "px");
    }
    async function executeEvent(action) {
        const view = APP_VIEWS.get(action);
        await view.execute();
    }
}
;
